import { NEW_PURCHASE_COMPLETED, BUY_AGAIN_COMPLETED, CHECK_STATUS_COMPLETED } from "./actions";
import AirtimeTokenService from "../services/AirtimeTokenService";

export const newTransaction = (transactionType, details) => async(dispatch) => {
    const req = {
        "tx_type": transactionType,
        "data": details
    }
    console.log(req);
    try {
        const res = await AirtimeTokenService.newPurchase({req});
        //console.log(res);
        dispatch({
            type: NEW_PURCHASE_COMPLETED,
            payload: res.data

        });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log("error");
        return Promise.reject(err);
    }

};

export const buyAgainTransaction = (id) =>async(dispatch) => {
    try {
        const req = {
            "tx_type": "buy_again",
            "data": {
                "id":id,
                
            }
        }
        const res = await AirtimeTokenService.buyAgain({req});
        dispatch({
            type: BUY_AGAIN_COMPLETED,
            payload: res.data
        });
        return Promise.resolve(res.data);
    } catch(err) {
        return Promise.reject(err);
    }

}

export const checkTransactionStatus = (id,status_type) => async(dispatch) => {
    try {
        const req = {
            "tx_type": "status",
            "data": {
                "tx_id":id,
                "status_type": status_type
            }
        }
        const res = await AirtimeTokenService.checkStatus({req});
        dispatch({
            type: CHECK_STATUS_COMPLETED,
            payload: res.data
        });
        return Promise.resolve(res.data);
    } catch(err) {
        return Promise.reject(err);
    }
}




